<button nz-button nzType="default" style="margin-bottom: 10px;" (click)="goBack()">
  <span nz-icon nzType="left" nzTheme="outline"></span>
  Back
</button>

<!-- <nz-ribbon [nzText]="userForm.get('status')?.value"
  [nzColor]="userForm.get('status')?.value == 'active' ? 'green' : 'red'"> -->
  <nz-card [nzLoading]="loading" nzTitle="User Profile">
    <div *ngIf="badgeImg" style="display: flex; flex-direction: column; align-items: center; gap: 8px; margin-bottom: 12px;">
      <img nz-image width="120px" height="120px" [nzSrc]="badgeImg" [nzPlaceholder]="placeholder" />
      <!-- <button *ngIf="hasPermission('view_documents')" nz-button nzType="default" nzDanger nzShape="round" nzSize="small" (click)="openBadgeDeny()"> -->
        <button *ngIf="hasPermission('view_documents')" nz-button nzType="default" nzDanger nzShape="round" nzSize="small" (click)="openBadgeDeny()"> 
        <span nz-icon nzType="stop" nzTheme="outline"></span>
        Deny Badge Photo
      </button>
    </div>

    <nz-tabset>

      <nz-tab nzTitle="Info">

        <form [formGroup]="userForm">

          <nz-form-item>
            <nz-form-label>User ID</nz-form-label>
            <input nz-input formControlName="user_id" placeholder="123" />
          </nz-form-item>

          <nz-form-item>
            <nz-form-label nzRequired>First Name</nz-form-label>
            <input nz-input formControlName="first_name" placeholder="John" />
          </nz-form-item>

          <nz-form-item>
            <nz-form-label nzRequired>Last Name</nz-form-label>
            <input nz-input formControlName="last_name" placeholder="Doe" />
          </nz-form-item>

          <nz-form-item>
            <nz-form-label>Email</nz-form-label>
            <input nz-input formControlName="email" placeholder="email@email.com" />
          </nz-form-item>

          <nz-form-item>
            <nz-form-label nzRequired>Phone</nz-form-label>
            <input nz-input mask="0(000) 000-0000" placeholder="1(123) 123-1234" formControlName="phone" />
          </nz-form-item>

          <nz-form-item>
            <nz-form-label>Date of Birth</nz-form-label>
            <input nz-input type="date" formControlName="date_of_birth" placeholder="YYYY-MM-DD" />
          </nz-form-item>

        </form>

        <div style="display: flex; gap: 5px; flex-direction: column; padding: 10px;">
          <button [nzLoading]="loading" nz-button nzType="primary" (click)="saveUserInfo()">Save User Info</button>
          <!-- <button [nzLoading]="loading" *ngIf="userForm.get('status')?.value == 'active'" (click)="updateStatus()"
            nz-button nzDanger nzType="primary">Deactivate</button>
          <button [nzLoading]="loading" *ngIf="userForm.get('status')?.value != 'active'" (click)="updateStatus()"
            nz-button nzType="primary">Activate</button> -->
        </div>

      </nz-tab>

      <nz-tab nzTitle="Portal(s)">

        <div *ngFor="let portal of portals; let i = index">
          
          <form [formGroup]="validateForm">
            
            <div formArrayName="portalForms">
              
              <div [formGroupName]="i">
                
                <nz-ribbon [nzText]="portal.status" [nzColor]="portal.status == 'active' ? 'green' : 'red'">
                  <nz-card [nzLoading]="portalLoading" [nzTitle]="portal.company_name">

                    <nz-form-item>
                      <nz-form-label>Recruiter</nz-form-label>
                      <nz-select
                        *ngIf="isSuperAdmin; else recruiterReadOnly"
                        style="width: 100%"
                        nzShowSearch
                        nzAllowClear
                        nzPlaceHolder="Search user"
                        formControlName="recruiter_id"
                        [nzDisabled]="!isSuperAdmin">
                        <nz-option *ngFor="let u of usersForSA" [nzValue]="u.id" [nzLabel]="u.first_name + ' ' + u.last_name"></nz-option>
                      </nz-select>
                      <ng-template #recruiterReadOnly>
                        <input nz-input formControlName="recruiter" placeholder="Recruiter" />
                      </ng-template>
                    </nz-form-item>
                    
                    <nz-form-item>
                      <nz-form-label>Providers</nz-form-label>
                      <nz-select 
                        [nzDisabled]="!hasPermission('manage_user_providers')" 
                        style="width: 100%;" 
                        nzMode="multiple" 
                        nzAllowClear 
                        nzShowSearch
                        nzPlaceHolder="Select providers (optional)" 
                        formControlName="providers">
                        <nz-option *ngFor="let p of portal?.options?.providers" [nzLabel]="p.name" [nzValue]="p.id"></nz-option>
                      </nz-select>
                      
                      <!-- <button *ngIf="isViewingOwnProfile" nz-button nzType="default" style="margin-top: 5px;" (click)="openRequestProviderModal()">
                        <span nz-icon nzType="plus" nzTheme="outline"></span>
                        Request Provider
                      </button> -->
                    </nz-form-item>

                    <nz-form-item>
                      <nz-form-label nzRequired>Role</nz-form-label>
                      <nz-select 
                        style="width: 100%;" 
                        nzShowSearch 
                        nzAllowClear 
                        formControlName="roleId"
                        nzPlaceHolder="Select users system role">
                        <nz-option *ngFor="let r of portal?.options?.roles" [nzValue]="r.id" [nzLabel]="r.name"></nz-option>
                      </nz-select>
                    </nz-form-item>

                    <nz-form-item>
                      <nz-form-label 
                        nzFor="dropdownField"
                        nzTooltipTitle="This field is for people having the ability to view all projects associated with this group(s). But not assigned to it."
                        nzTooltipIcon="info-circle">
                        Viewable Group(s)
                      </nz-form-label>
                      <nz-select 
                        style="width: 100%;" 
                        nzMode="multiple" 
                        nzAllowClear 
                        nzShowSearch
                        formControlName="groupsVisibility" 
                        nzPlaceHolder="Select groups user has access to see (optional)">
                        <nz-option *ngFor="let g of portal?.options?.groups" [nzValue]="g.id" [nzLabel]="g.name"></nz-option>
                      </nz-select>
                    </nz-form-item>

                    <nz-form-control>
                      <nz-form-label 
                        nzFor="dropdownField"
                        nzTooltipTitle="Fidium only external values, used for mapping from fidium master"
                        nzTooltipIcon="info-circle">
                        Fidium Externals (Press Enter to Add, Then Save)
                      </nz-form-label>
                      
                      <input 
                        nz-input 
                        formControlName="fidiumInput" 
                        (keyup.enter)="addChip(i)"
                        placeholder="Add a Fidium External"/>

                      <nz-tag 
                        nzColor="blue" 
                        style="margin-top: 5px; margin-bottom: 5px; padding: 5px"
                        *ngFor="let chip of getFidiumChips(i)" 
                        nzMode="closeable" 
                        (nzOnClose)="removeChip(i, chip)">
                        {{ chip }}
                      </nz-tag>
                    </nz-form-control>

                    <button nz-button type="button" nzType="primary" (click)="addProviderExternal(i)">
                      Add Provider External
                    </button>

                    <div formArrayName="providerExternals" style="margin-top: 10px;">
                      
                      <div *ngFor="let group of getNestedExternals(i).controls; let j = index" [formGroupName]="j">
                        <nz-space style="display: flex; margin-bottom: 5px;">
                          
                          <nz-select formControlName="key" [nzPlaceHolder]="'Select provider'" style="width: 150px;">
                            <nz-option *ngFor="let p of portal.options.providers" [nzLabel]="p.name" [nzValue]="p.id"></nz-option>
                          </nz-select>

                          <input [readonly]="!group.get('key')?.value" nz-input formControlName="value" placeholder="Enter value" />

                          <button nz-button nzType="primary" nzDanger (click)="removeProviderExternal(i, j)">
                            <span nz-icon nzType="delete"></span>
                          </button>

                        </nz-space>
                      </div>
                    </div>

                    <nz-form-item>
                      <nz-form-label>Can add pins?</nz-form-label>
                      <nz-form-control>
                        <label nz-checkbox formControlName="pins"></label>
                      </nz-form-control>
                    </nz-form-item>

                    <nz-form-item>
                      <nz-form-label>Can add areas?</nz-form-label>
                      <nz-form-control>
                        <label nz-checkbox formControlName="areas"></label>
                      </nz-form-control>
                    </nz-form-item>

                    <button nz-button nzType="primary" (click)="savePortal(i)">Save Changes</button>
                    <button *ngIf="portal?.status == 'active'" nz-button nzType="primary" (click)="deactivate(i)" nzDanger>Deactivate</button>
                    <button *ngIf="portal?.status == 'inactive'" nz-button nzType="primary" (click)="activate(i)">Activate</button>

                  </nz-card>
                </nz-ribbon>
                
              </div>
            </div>
          </form>
        </div>

      </nz-tab>

      <nz-tab nzTitle="Documents" (nzClick)="getPortalDocs()">

        <button *ngIf="hasPermission('view_documents')" nz-button nzType="primary" (click)="addDocument()">Add Document</button>

        <nz-table [nzLoading]="docLoading" #docsTable [nzData]="repDocs" nzBordered nzShowSizeChanger>
          <thead>
            <tr>
              <th>Document</th>
              <th>Status</th>
              <th>Sent Date</th>
              <th>Completed Date</th>
              <th *ngIf="repDocs?.[0]?.company">Company</th>
              <th *ngIf="hasPermission('view_documents')"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let d of docsTable.data">
              <td>{{ d.name }}</td>
              <td>
                <nz-tag
                  [nzColor]="d.status == 'completed' ? 'green' : d.status == 'opened' ? 'yellow' : d.status == 'denied' ? 'red' : 'default'">
                  {{ d.status | titlecase }}
                </nz-tag>
              </td>
              <td>{{ d.created_at | date }}</td>
              <td>{{ d.completed_date | date }}</td>
              <td>{{ d.company }}</td>
              <td *ngIf="hasPermission('view_documents')">
                <div style="display: flex; gap: 2px;">
                  <button *ngIf="d?.file_path" nz-button nz-popover nzPopoverContent="Download Document"
                    nzType="primary" nzShape="circle" (click)="openDoc(d)">
                    <span nz-icon nzType="eye" nzTheme="outline"></span>
                  </button>
                  <button *ngIf="d?.file_path" nz-button nz-popover nzPopoverContent="View Document" nzType="primary"
                    nzShape="circle" (click)="viewDoc(d)">
                    <span nz-icon nzType="folder-view" nzTheme="outline"></span>
                  </button>
                  <button *ngIf="d.status != 'denied' && d.status != 'sent'" nz-button nz-popover nzType="primary"
                    nzPopoverContent="Deny Document" nzDanger nzShape="circle" (click)="denyDoc(d)">
                    <span nz-icon nzType="close-circle" nzTheme="outline"></span>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </nz-table>

      </nz-tab>

      <nz-tab *ngIf="hasPermission('manage_user_quizzes')" nzTitle="Quizzes" (nzClick)="getUserQuizzes()">
        <div style="margin-bottom: 12px; display: flex; justify-content: flex-end;">
          <button nz-button nzType="primary" (click)="openAssignQuizModal()">
            <span nz-icon nzType="plus"></span>
            Assign Quiz
          </button>
        </div>
        <nz-table #quizTable [nzLoading]="quizLoading" [nzData]="userQuizzes" nzBordered>
          <thead>
            <tr>
              <th>Quiz</th>
              <th>Status</th>
              <th>Score</th>
              <th>Completed</th>
              <th *ngIf="userQuizzes?.[0]?.company">Company</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let q of quizTable.data">
              <td>{{ q.name }}</td>
              <td>
                <nz-tag [nzColor]="q.completed ? 'green' : 'orange'">
                  {{ q.completed ? 'Passed' : 'Pending' }}
                </nz-tag>
              </td>
              <td>{{ q.score != null ? (q.score + '%') : '—' }}</td>
              <td>{{ q.completed_at ? (q.completed_at | date: 'short') : '—' }}</td>
              <td>{{ q.company }}</td>
            </tr>
          </tbody>
        </nz-table>
      </nz-tab>

      <nz-tab *ngIf="canSeePayHierarchy" nzTitle="Pay Hierarchy" (nzClick)="payHierarchyTab()">
        <div style="display: flex; flex-direction: column; gap: 12px;">
          <nz-card>
            <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px;">
              <div>
                <div style="font-weight: 600;">Create Hierarchy</div>
              </div>
              <div style="display: flex; gap: 8px;">
                <button [disabled]="!currentUser?.super_admin" nz-button nzType="primary" nzShape="round" type="button" [nzLoading]="payHierarchyLoading" (click)="saveHierarchy()">
                  <span nz-icon nzType="plus-circle"></span>
                  {{ editingHierarchyId ? 'Update' : 'Create' }}
                </button>
                <button [disabled]="!currentUser?.super_admin" nz-button nzType="default" nzShape="round" type="button" (click)="startNewHierarchy()">
                  <span nz-icon nzType="reload"></span>
                  Clear
                </button>
              </div>
            </div>

            <form [formGroup]="payHierarchyForm" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 10px;">
              <nz-form-item>
                <nz-form-label>Provider</nz-form-label>
                <nz-select [nzDisabled]="!currentUser?.super_admin" style="width: 100%;" nzShowSearch nzAllowClear formControlName="provider_id" nzPlaceHolder="Select provider"
                  (ngModelChange)="onHierarchyProviderChange($event)">
                  <nz-option *ngFor="let p of sort()" [nzLabel]="p.name" [nzValue]="p.id"></nz-option>
                </nz-select>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label>Company</nz-form-label>
                <nz-select [nzDisabled]="!currentUser?.super_admin" style="width: 100%;" nzAllowClear nzShowSearch formControlName="company_id" nzPlaceHolder="Select company">
                  <nz-option *ngFor="let c of companies" [nzLabel]="c.name" [nzValue]="c.id"></nz-option>
                </nz-select>
              </nz-form-item>
              <nz-form-item>
            </nz-form-item>
              <nz-form-item style="grid-column: 1 / -1;">
                <nz-form-label>Associated Users</nz-form-label>
                <nz-select [nzDisabled]="!currentUser?.super_admin" style="width: 100%;" nzMode="multiple" nzAllowClear nzShowSearch formControlName="associated_users"
                  nzPlaceHolder="Select users for provider">
                  <nz-option *ngFor="let u of payHierarchyEligibleUsers" [nzValue]="u.id" [nzLabel]="u.first_name + ' ' + u.last_name"></nz-option>
                </nz-select>
              </nz-form-item>
            </form>
          </nz-card>

          <nz-card>
            <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px;">
              <div style="font-weight: 600;">Existing Hierarchies</div>
              <div style="color: #888; font-size: 12px;">Click view to see members</div>
            </div>
            <nz-table [nzLoading]="payHierarchyLoading" [nzData]="payHierarchyList" nzBordered>
              <thead>
                <tr>
                  <th>Provider</th>
                  <th>Company</th>
                  <th>Owner</th>
                  <th>Associated Users</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let h of payHierarchyList">
                  <td>{{ getProviderName(h.provider_id) || h.provider_name || h.provider_id }}</td>
                  <td>{{ getCompanyName(h.company_id) || h.company_id || '-' }}</td>
                  <td>{{ h.user_name || h.user_id | titlecase }}</td>
                  <td>{{ h.associated_users?.length || 0 }}</td>
                  <td style="display: flex; gap: 6px;">
                  <button nz-button nzSize="small" nzType="default" nzShape="round" (click)="viewHierarchy(h)">
                    <span nz-icon nzType="eye"></span>
                    View
                  </button>
                  <button [disabled]="!currentUser?.super_admin" nz-button nzSize="small" nzType="default" nzShape="round" (click)="editHierarchy(h)">
                    <span nz-icon nzType="edit"></span>
                    Edit
                  </button>
                  <button [disabled]="!currentUser?.super_admin" nz-button nzType="primary" nzDanger nzSize="small" nzShape="round" (click)="deleteHierarchy(h.id)">
                    <span nz-icon nzType="delete"></span>
                    Delete
                  </button>
                </td>
              </tr>
            </tbody>
            </nz-table>
          </nz-card>
        </div>
      </nz-tab>

      <nz-modal [(nzVisible)]="editHierarchyModal" nzTitle="Edit Pay Hierarchy" (nzOnCancel)="closeEditHierarchy()" (nzOnOk)="saveEditHierarchy()" [nzWidth]="'520px'">
        <ng-container *nzModalContent>
          <form [formGroup]="editHierarchyForm" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 10px; padding-top: 4px;">
            <nz-form-item>
              <nz-form-label>Provider</nz-form-label>
              <nz-select style="width: 100%;" nzShowSearch nzAllowClear formControlName="provider_id" nzPlaceHolder="Select provider"
                (ngModelChange)="onHierarchyProviderChange($event)">
                <nz-option *ngFor="let p of sort()" [nzLabel]="p.name" [nzValue]="p.id"></nz-option>
              </nz-select>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label>Company</nz-form-label>
              <nz-select style="width: 100%;" nzAllowClear nzShowSearch formControlName="company_id" nzPlaceHolder="Select company">
                <nz-option *ngFor="let c of companies" [nzLabel]="c.name" [nzValue]="c.id"></nz-option>
              </nz-select>
            </nz-form-item>
            <nz-form-item></nz-form-item>
            <nz-form-item style="grid-column: 1 / -1;">
              <nz-form-label>Associated Users</nz-form-label>
              <nz-select style="width: 100%;" nzMode="multiple" nzAllowClear nzShowSearch formControlName="associated_users"
                nzPlaceHolder="Select users for provider">
                <nz-option *ngFor="let u of payHierarchyEligibleUsers" [nzValue]="u.id" [nzLabel]="u.first_name + ' ' + u.last_name"></nz-option>
              </nz-select>
            </nz-form-item>
          </form>
        </ng-container>
      </nz-modal>

      <nz-modal [(nzVisible)]="viewHierarchyModal" nzTitle="Hierarchy Members" (nzOnCancel)="closeViewHierarchy()" [nzFooter]="null" [nzWidth]="'480px'">
        <ng-container *nzModalContent>
          <div style="margin-bottom: 10px; padding: 8px 10px; background: #fafafa; border: 1px solid #f0f0f0; border-radius: 6px;">
            <div style="font-size: 12px; color: #666;">Owner</div>
            <div style="font-weight: 600;">{{ viewHierarchyOwner || '—' | titlecase }}</div>
          </div>
          <nz-list *ngIf="viewHierarchyUsers?.length; else emptyHierarchy" [nzDataSource]="viewHierarchyUsers" [nzRenderItem]="item" nzBordered nzSize="small">
            <ng-template #item let-u>
              <nz-list-item>
                <span>{{ (u.name || u.user_id) | titlecase }}</span>
              </nz-list-item>
            </ng-template>
          </nz-list>
          <ng-template #emptyHierarchy>
            <nz-empty nzNotFoundContent="No associated users"></nz-empty>
          </ng-template>
        </ng-container>
      </nz-modal>

      <nz-tab *ngIf="hasPermission('view_user_backgrounds')" nzTitle="Backgrounds" (nzClick)="backgroundsTab()">
        <button style="margin: 10px;" nz-button nzType="primary" (click)="addBackground()">
          <nz-icon nzType="plus-circle" />
          Add Background
        </button>

        <nz-table #bgTable [nzLoading]="bgLoader" [nzData]="usersBackgrounds" nzBordered [nzFrontPagination]="false">
          <thead>
            <tr>
              <th>ID</th>
              <th>Provider</th>
              <th>Status</th>
              <th>Sent Date</th>
              <th>Completed Date</th>
              <th>Failed Date</th>
              <th>Last Updated</th>
              <th *ngIf="usersBackgrounds?.[0]?.company">Company</th>
              <th *ngIf="hasPermission('manage_user_backgrounds')"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let bg of bgTable.data">
              <td>{{ bg.background_id || '-' }}</td>
              <td>{{ bg.provider }}</td>
              <td>
                <nz-tag
                  [nzColor]="bg.status == 'Passed' ? 'green' : bg.status == 'Failed' ? 'red' : bg.status == 'Exception' ? 'blue' : bg.status == 'Pending' ? 'orange' : bg.status == 'Archived' ? 'purple' : 'yellow' ">
                  {{ bg.status }}
                </nz-tag>
              </td>
              <td>{{ bg.created_at | date }}</td>
              <td>{{ bg.completed_at | date }}</td>
              <td>{{ bg.failed_at | date }}</td>
              <td>{{ bg.updated_at | date }}</td>
              <td>{{ bg.company }}</td>
              <td *ngIf="hasPermission('manage_user_backgrounds')">
                <button nz-button nz-popover nzPopoverContent="Edit Background" nzType="primary" nzShape="circle"
                  (click)="editBackgroundCheck(bg)">
                  <span nz-icon nzType="edit" nzTheme="outline"></span>
                </button>
              </td>
            </tr>
          </tbody>
        </nz-table>

      </nz-tab>

      <nz-tab *ngIf="hasPermission('view_user_provider_payplans')" nzTitle="Provider Payplans" (nzClick)="getUserPlans()" >

        <div style="display: flex; flex-direction: column; gap: 12px;">
          <nz-card>
            <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px;">
              <div>
                <div style="font-weight: 600;">Provider Payplans</div>
              </div>
              <div style="display: flex; gap: 8px;">
                <button [disabled]="!hasPermission('manage_provider_payplans')" nz-button nzType="primary" nzShape="round" type="button" [nzLoading]="payHierarchyLoading" (click)="providerPlans()">
                  <span nz-icon nzType="plus-circle"></span>
                  Add Plan
                </button>
              </div>
            </div>


            <nz-table [nzLoading]="payHierarchyLoading" [nzData]="userPlans" nzBordered>
              <thead>
                <tr>
                  <th>Plan</th>
                  <th>Provider</th>
                  <th>Status</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let p of userPlans">
                  <td>{{ p.name }}</td>
                  <td>{{ p.provider | titlecase}}</td>
                  <td>{{ p.status }}</td>
                  <td>{{ p.start_date | date }}</td>
                  <td>{{ p?.end_date | date }}</td>
                  <td>
                  <button *ngIf="p.status == 'active'" nz-button nzSize="small" nzType="default" nzDanger nzShape="round" (click)="updatePlanStatus(p)">
                    Deactivate
                  </button>
                </td>
              </tr>
            </tbody>
            </nz-table>

          </nz-card>


        </div>
      </nz-tab>

      <nz-tab *ngIf="hasPermission('view_user_logs')" nzTitle="Logs" (nzClick)="getUserLogs()">
        <form [formGroup]="noteForm">
            <nz-form-item>
                <nz-form-control>
                    <nz-textarea-count [nzMaxCharacterCount]="150">
                        <textarea rows="4" maxlength="150" nz-input placeholder="Add a note" formControlName="note"></textarea>
                    </nz-textarea-count>
                </nz-form-control>
            </nz-form-item>
        </form>
        <div class="btn-note-cont">
            <button nz-button nzType="default" (click)="noteForm.reset()">Reset Note</button>
            <button nz-button nzType="primary" (click)="addNote()" [disabled]="noteForm.invalid">Save Note</button>
        </div>
        <nz-list nzItemLayout="horizontal" style="height: 45vh; overflow: scroll;">
            <nz-list-item *ngFor="let log of userLogs">
            <nz-list-item-meta [nzDescription]="log?.by ? log?.by : 'System'">
                <nz-list-item-meta-title>
                <p style="color: grey;" *ngIf="log?.type == 'log'"> ~ {{log?.date | date}}: {{ log?.text }} </p>
                <p *ngIf="log?.type == 'note'"> {{log?.date | date}}:  {{ log.text }} </p>
                </nz-list-item-meta-title>
            </nz-list-item-meta>
            </nz-list-item>
        </nz-list>
      </nz-tab>

    </nz-tabset>

    <nz-modal class="assign-quiz-modal" [(nzVisible)]="assignQuizModal" nzTitle="Assign Quiz" nzWidth="520px"
      (nzOnCancel)="assignQuizModal = false" (nzOnOk)="assignQuizToUser()">
      <ng-container *nzModalContent>
        <form [formGroup]="assignQuizForm" class="modal-form modal-form-single">
          <label class="modal-label">Quiz</label>
          <nz-select formControlName="quiz_id" nzPlaceHolder="Select a quiz" nzShowSearch style="width: 100%;">
            <nz-option *ngFor="let quiz of allQuizzes" [nzValue]="quiz.id" [nzLabel]="quiz.name"></nz-option>
          </nz-select>
        </form>
      </ng-container>
    </nz-modal>


  </nz-card>

<!-- </nz-ribbon> -->


<nz-modal [(nzVisible)]="planProviderModal" (nzOnCancel)="closePlanModal()" (nzOnOk)="saveProviderPlans()">
  <ng-container *nzModalContent>

    <form [formGroup]="planProviderForm">
      <nz-form-item>
        <nz-form-label>Plan</nz-form-label>
        <nz-select style="width: 100%;" nzShowSearch nzAllowClear formControlName="plan_id" nzPlaceHolder="Select plan">
          <nz-option *ngFor="let p of availableProviderPlans" [nzLabel]="p.provider" [nzValue]="p"></nz-option>
        </nz-select>
      </nz-form-item>
    </form>

  </ng-container> 
</nz-modal>

<nz-modal [nzStyle]="{ width: '95vw', height: '95vh' }"
  [nzBodyStyle]="{ height: 'calc(90vh - 55px)', overflow: 'auto' }" [(nzVisible)]="docModal" nzTitle="Document Modal"
  nzCentered (nzOnCancel)="closeDoc()" [nzFooter]="null">
  <ng-container *nzModalContent>

    <iframe [src]="docUrl" width="100%" height="100%"></iframe>

  </ng-container>
</nz-modal>

<nz-modal [nzStyle]="{width: '95vw', height: '95vh'}" [nzBodyStyle]="{ height: 'calc(90vh - 55px)', overflow: 'auto' }"
  [(nzVisible)]="docSpecModal" nzTitle="Document Data" nzCentered (nzOnCancel)="closeDocSpec()" [nzFooter]="null">
  <ng-container *nzModalContent>
    <div class="doc-spec-list" *ngIf="docSpecs.length; else emptyDocSpecs">
      <div class="doc-spec-list__bulk">
        <div class="doc-spec-list__bulk-actions">
          <button type="button" nz-button nzType="primary" nzShape="round" (click)="copyAllDocSpecs()">
            <span nz-icon nzType="copy" nzTheme="outline"></span>
            Copy All
          </button>
        </div>
        <textarea nz-input class="doc-spec-list__bulk-textarea" rows="2" readonly>{{ docSpecCombined }}</textarea>
      </div>
      <nz-list nzBordered nzSize="large" class="doc-spec-list__container">
        <nz-list-item class="doc-spec-list__item" *ngFor="let spec of docSpecs; trackBy: trackDocSpecBy">
          <div class="doc-spec-list__row">
            <div class="doc-spec-list__text">
              <div class="doc-spec-list__field">
                <span class="doc-spec-list__field-label">{{ spec.field }}</span>
                <!-- <span class="doc-spec-list__index">#{{ spec.index + 1 }}</span> -->
              </div>
              <div class="doc-spec-list__value">
                <span *ngIf="isBooleanValue(spec.value)" class="doc-spec-list__boolean">
                  {{ spec.value ? 'Yes' : 'No' }}
                </span>
                <img *ngIf="!isBooleanValue(spec.value) && isLikelyUrl(spec.value)" class="doc-spec-list__link"
                  [src]="getDocSpecDisplayValue(spec)" target="_blank" rel="noopener noreferrer"/>
                <span *ngIf="!isBooleanValue(spec.value) && !isLikelyUrl(spec.value)" class="doc-spec-list__value-text">
                  {{ getDocSpecDisplayValue(spec) }}
                </span>
              </div>
            </div>
            <button *ngIf="!isBooleanValue(spec.value) && !isLikelyUrl(spec.value)" type="button" nz-button nzType="default" nzSize="small" nzShape="round" nz-tooltip
              nzTooltipTitle="Copy value" (click)="copyDocSpecValue(spec.value)">
              <span nz-icon nzType="copy" nzTheme="outline"></span>
            </button>
          </div>
        </nz-list-item>
      </nz-list>
    </div>
    <ng-template #emptyDocSpecs>
      <nz-empty nzNotFoundContent="No document information available"></nz-empty>
    </ng-template>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="backgroundModal" nzTitle="Background Check" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
  <ng-container *nzModalContent>

    <form [formGroup]="backgroundForm">

      <nz-form-item>
        <nz-form-label>Background ID</nz-form-label>
        <input nz-input formControlName="backgroundId" placeholder="123" />
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Company</nz-form-label>
        <nz-select style="width: 100%;" nzAllowClear nzShowSearch nzPlaceHolder="Select Company" (ngModelChange)="onCompanyChange($event)"
          formControlName="companyId">
          <nz-option *ngFor="let c of companies" [nzLabel]="c.name" [nzValue]="c.id"></nz-option>
        </nz-select>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Provider</nz-form-label>
        <nz-select style="width: 100%;" nzAllowClear nzShowSearch nzPlaceHolder="Select Provider"
          formControlName="providerId">
          <nz-option *ngFor="let p of sort()" [nzLabel]="p.name" [nzValue]="p.id"></nz-option>
        </nz-select>
      </nz-form-item>

      <nz-form-item *ngIf="backgroundForm?.get('id')?.value">
        <nz-form-label>Status</nz-form-label>
        <nz-select style="width: 100%;" nzAllowClear nzShowSearch nzPlaceHolder="Select status"
          formControlName="status">
          <nz-option nzLabel="Sent" nzValue="Sent"></nz-option>
          <nz-option nzLabel="Pending" nzValue="Pending"></nz-option>
          <nz-option nzLabel="Passed" nzValue="Passed"></nz-option>
          <nz-option nzLabel="Failed" nzValue="Failed"></nz-option>
          <nz-option nzLabel="Archived" nzValue="Archived"></nz-option>
          <nz-option nzLabel="Exception" nzValue="Exception"></nz-option>
        </nz-select>
      </nz-form-item>

      <nz-form-item *ngIf="backgroundForm?.get('id')?.value">
        <nz-form-label>Completed Date</nz-form-label>
        <nz-date-picker style="width: 100%;" formControlName="completedDate"></nz-date-picker>
      </nz-form-item>

      <nz-form-item *ngIf="backgroundForm?.get('id')?.value">
        <nz-form-label>Failed Date</nz-form-label>
        <nz-date-picker style="width: 100%;" formControlName="failedDate"></nz-date-picker>
      </nz-form-item>

    </form>

  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="denyModal" nzTitle="Deny document" (nzOnCancel)="handleDenyCancel()" (nzOnOk)="saveDenyDoc()">
  <ng-container *nzModalContent>
    <p>Are you sure you want to deny {{deniedDoc?.name}}?</p>
    <input nz-input placeholder="Reason for denying the document" [(ngModel)]="denyReason" />
    <label style="margin: 5px;" nz-checkbox [(ngModel)]="checked">Alert the rep?</label>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="badgeDenyModal" nzTitle="Deny badge photo" (nzOnCancel)="handleBadgeDenyCancel()" (nzOnOk)="denyBadgeImage()">
  <ng-container *nzModalContent>
    <p>Are you sure you want to deny this badge photo?</p>
    <input nz-input placeholder="Reason for denying the badge" [(ngModel)]="badgeDenyReason" />
    <label style="margin: 5px;" nz-checkbox [(ngModel)]="badgeNotify">Notify the rep?</label>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="requestProviderModal" nzTitle="Request Provider" (nzOnCancel)="closeRequestProviderModal()"
  (nzOnOk)="submitProviderRequest()">
  <ng-container *nzModalContent>
    <form [formGroup]="requestProviderForm">
      <nz-form-item>
        <nz-form-label>Provider</nz-form-label>
        <nz-select style="width: 100%;" nzMode="multiple" nzAllowClear nzShowSearch nzPlaceHolder="Select providers to request"
          formControlName="provider_ids">
          <nz-option *ngFor="let p of availableProviders" [nzLabel]="p.name" [nzValue]="p.id"></nz-option>
        </nz-select>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="documentModal" nzTitle="Assign Document" (nzOnCancel)="handleDocumentCancel()" (nzOnOk)="handleDocumentOk()" [nzOkLoading]="documentLoading" [nzCancelLoading]="documentLoading">
  <ng-container *nzModalContent>
    <form [formGroup]="documentForm">

      <nz-form-item>
        <nz-form-label>Company</nz-form-label>
        <nz-select style="width: 100%;" nzAllowClear nzShowSearch nzPlaceHolder="Select Company" formControlName="company_id" (ngModelChange)="getAvailableCompanyDocs()">
          <nz-option *ngFor="let company of portalsCompanies" [nzLabel]="company.name" [nzValue]="company.id"></nz-option>
        </nz-select>
      </nz-form-item>

      <nz-form-item *ngIf="documentForm.get('company_id')?.value">
        <nz-form-label>Documents</nz-form-label>
        <nz-select nzMode="multiple" [nzLoading]="documentLoading" nzRequired style="width: 100%;" nzAllowClear nzShowSearch nzPlaceHolder="Select document" formControlName="document_id">
          <nz-option *ngFor="let doc of availableDocuments" [nzLabel]="doc.name" [nzValue]="doc.id"></nz-option>
        </nz-select>
      </nz-form-item>

    </form>
  </ng-container>
</nz-modal>
